<template>
  <div>
    <div class="flex flex-row gap-4 relative h-12 language-container">
      <div v-for="(locale, i) in locales" :key="locale">
        <button
            @click="toggleOrSelectLocale(locale)"
            class="language-button absolute transition-all duration-300"
            :class="locale === i18n.locale ? 'language-button-active z-50' : 'z-40'"
            :style="positions[i]"
        >
          {{ locale.toUpperCase() }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Locale } from "~/lib/types";

const open = ref(false);
const locales: Locale[] = ["de", "fr", "it"];
const positions = computed(() => {
  return locales.map((_, i) => {
    return {
      right: open.value ? `${buttonSpacing * (locales.length - 1 - i)}rem` : "0",
    };
  });
});
const i18n = useI18nStore();

const buttonSpacing = 4;

const toggleOrSelectLocale = (locale: Locale) => {
  if (open.value && i18n.locale !== locale) {
    i18n.setLocale(locale);
    open.value = false;
  } else {
    open.value = !open.value;
  }
};
</script>

<style lang="postcss" scoped>
.language-button {
  @apply text-base flex items-center justify-center text-[#FF6436] font-bold;
  width: 48px;
  height: 48px;
  background-color: #FFF9E2;
  border: #FF6436 1px solid;
}

.overlay-header{
  .language-button {
    border: #FFF9E2 1px solid;
  }
  .language-button-active {
    background: #FF6436;
    border: #FFF9E2 1px solid;
    color: #FFF9E2;
  }
}

.language-container {
  top: 0;
  right: 0;
}
.language-button-active {
  background-color: #FFF9E2;
}

.language-button {
  @apply transition-all duration-300;
}
</style>
